import { RateOrderScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <RateOrderScreen />;
}
